

export enum TaskTypeSettingsVersion {
    V1 = 1,
    V2 = 2,
}
